import { Button, VStack, useDisclosure } from '@chakra-ui/react';
import PageCard from '../../components/page-card';
import { translate } from '../../i18n';
import CreateGameDurationForm from './components/CreateGameDurationForm';
import GameDurationsList from './components/GameDurationsList';

export default function GameDurationManagementPage() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <PageCard
        title={translate('game_durations.title')}
        rightHeader={
          <Button
            colorScheme="brand"
            onClick={onOpen}
          >
            {translate('game_durations.add_duration')}
          </Button>
        }
      >
        <VStack spacing={6} align="stretch">
          <GameDurationsList />
        </VStack>
      </PageCard>

      <CreateGameDurationForm
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
}